import { FC, useEffect } from "react";
import { useKeycloak } from "@react-keycloak/ssr";
import { useHistory, useLocation } from "react-router-dom";
import { removeUrlParam } from "../util/url";
import { usePortalProvider } from "../providers/portal-provider";

type TokenClaims = {
  name?: string;
  preferred_username?: string;
  [key: string]: unknown;
};

function getTokenClaims(authClient: unknown): TokenClaims | undefined {
  return (authClient as { tokenParsed?: TokenClaims })?.tokenParsed;
}

export const LoginContainer: FC = ({ children }) => {
  const { keycloak, initialized } = useKeycloak();
  const { accessToken, setAccessToken } = usePortalProvider();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (initialized && keycloak?.token) {
      setAccessToken(keycloak.token);
    } else if (!accessToken) {
      setAccessToken(undefined);
    }

    let url = location.search;
    let hash = location.hash;

    url = removeUrlParam(url, "code");
    url = removeUrlParam(url, "state");
    url = removeUrlParam(url, "session_state");
    url = removeUrlParam(url, "iss");
    url = removeUrlParam(url, "noRedirect");
    url = removeUrlParam(url, "authError");

    history.replace({
      search: url,
      hash: hash,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keycloak, initialized, accessToken, setAccessToken]);

  return <>{children}</>;
};
